import Tabs from "./Tabs";
import ProgressStepIndicator from "./ProgressStepIndicator";

export default function ({ success, modifiedData, ml, NextId, options, variant, IsSectionCompleted,isLink ,...props }) {
  let Component;
  [Component, variant] =
    variant === "stepperNav"
      ? [ProgressStepIndicator]
      : variant === "underlinedTabs"
        ? [Tabs, "underlined"]
        : variant === "boxTabs"
          ? [Tabs, "box"]
          : [Tabs, "outlined"];
  return (
    <Component success={success} modifiedData={modifiedData} tabs={options} steps={options} {...props} NextId={NextId} IsSectionCompleted={IsSectionCompleted} variant={variant} ml={ml} isLink={isLink}/>
  );
}
